export const isImage = (contentType: string) =>
  ["png", "jpg", "jpeg", "gif", "bmp"].includes(contentType.toLowerCase());

export const canIframePreview = (contentType: string) =>
  ["pdf", "mp4", "mp3"].includes(contentType.toLowerCase());

export const canPreview = (contentType: string) =>
  isImage(contentType) || canIframePreview(contentType);
